import React, { useContext, useState } from "react";
import { Context } from "../../App";
import Button from "../../Components/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Photo } from "../../Contract/Photos";
import EditPhotoModal from "./EditPhotoModal";
import { PhotosApi } from "../../services/photoService";

type Props = {};
export type ModalState = {
  open: boolean;
  photo?: Photo;
};

export default function Photos({}: Props) {
  const { photos, setPhotos } = useContext(Context);
  const [modalState, setModalState] = useState<ModalState>({ open: false });
  return (
    <>
      <Button
        className="secondary-btn p-3"
        onClick={() => setModalState({ open: true, photo: undefined })}
      >
        <FontAwesomeIcon icon={faPlus} /> Add Photo
      </Button>
      <div className="photo-grid p-4">
        {photos.map((photo, i) => (
          <div
            key={i}
            className="photo-tile"
            onClick={() =>
              setModalState({
                open: true,
                photo,
              })
            }
          >
            <img className="photo-preview" src={photo.url} alt={photo.name} />
            {photo.name}
          </div>
        ))}
      </div>
      <EditPhotoModal
        state={modalState}
        setState={setModalState}
        onSaved={() => {
          new PhotosApi().getPhotos().then(setPhotos);
          setModalState({ open: false });
        }}
      />
    </>
  );
}
